/* eslint-disable max-classes-per-file */
import React, { Component } from 'react'
import { IdentifierReel } from 'stylewhere/api'
import { Box, Modal, KeyValueRow, Spacer, ModalTitle } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'

interface Props {
  onClose: () => void
  reel: IdentifierReel
  visible: boolean
}

export class ReelInfoModal extends Component<Props> {
  render() {
    const { visible, onClose, reel } = this.props

    return (
      <Modal size="lg" onClose={onClose} visible={visible} fullContent showCloseButton>
        <Box p={30}>
          <ModalTitle title={__(T.misc.reel_info)} data-testid={`reel-modal-title`} />
          <Box>
            <KeyValueRow label={__(T.misc.code)} variant="grey" value={reel?.code} />
            <Spacer />
            <KeyValueRow label={__(T.misc.assigned_supplier)} variant="grey" value={reel?.place?.description} />
            <Spacer />
            <KeyValueRow label={__(T.misc.only_quantity)} variant="grey" value={reel?.quantity} />
          </Box>
        </Box>
      </Modal>
    )
  }
}
